import React from 'react';
import PropertySearch from '../../components/PropertySearch';
import PropertyGrid from '../../components/PropertyGrid';
import { useMLSPortal } from '../../../../../hooks/useMLSPortal';
import { Container } from 'react-bootstrap';

const PropertySearchAgent: React.FC = () => {
  const {
    properties,
    loading,
    error,
    searchProperties
  } = useMLSPortal();

  const handleSearch = (filters: any) => {
    // Add agent-specific filters or logic here
    searchProperties(filters);
  };

  return (
    <Container fluid className="p-0">
      <div className="mb-4">
        <PropertySearch 
          onSearch={handleSearch}
          loading={loading}
        />
      </div>
      
      <PropertyGrid
        properties={properties}
        loading={loading}
        error={error}
        onViewDetails={(property) => {
          // Handle agent-specific property view
          console.log('Agent viewing property:', property);
        }}
        onFavorite={(propertyId) => {
          // Handle agent favorites
          console.log('Agent favoriting property:', propertyId);
        }}
      />
    </Container>
  );
};

export default PropertySearchAgent;